module.exports = __webpack_public_path__ + "static/media/award3.f88ff1b1.png";